import { render } from "./SectionFeaturesTabContent.vue?vue&type=template&id=567dc724&scoped=true"
import script from "./SectionFeaturesTabContent.vue?vue&type=script&lang=js"
export * from "./SectionFeaturesTabContent.vue?vue&type=script&lang=js"

import "./SectionFeaturesTabContent.vue?vue&type=style&index=0&id=567dc724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567dc724"]])

export default __exports__